export const validateEmail = (email) => {
  if (!email) {
    return "Email is required";
  }
  const normalizedEmail = email.trim().toLowerCase();
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(normalizedEmail)) {
    return "Invalid email format";
  }
  if (!normalizedEmail.endsWith("@barterflip.com")) {
    return "The email is not valid";
  }
  return "";
};

export const validatePassword = (password) => {
  if (!password) {
    return "Password is required";
  }
  if (password.length < 6) {
    return "Password must be at least 6 characters";
  }
  if (password.length > 16) {
    return "Password must be at most 16 characters";
  }
  if (!/\d/.test(password)) {
    return "Password must contain at least one number";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must contain at least one lowercase letter";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter";
  }
  return "";
};

export const validatePhone = (phone) => {
  if (!phone) {
    return "Phone number is required";
  }
  // Validar que solo contenga números y tenga al menos 10 dígitos
  const re = /^\d{10,}$/;
  if (!re.test(phone.replace(/[^0-9]/g, ""))) {
    return "Invalid phone number format";
  }
  return "";
};

export const validateCode = (code) => {
  if (!code) {
    return "Code is required";
  }
  // Validar que solo contenga números
  const re = /^\d+$/;
  if (!re.test(code.replace(/[^0-9]/g, ""))) {
    return "Invalid code format";
  }
  return "";
};

export const validatePackageName = (packageName) => {
  if (!packageName) {
    return "Package name is required";
  }
  return "";
};

export const validateQuantity = (quantity) => {
  if (!quantity) {
    return "Quantity is required";
  }
  return "";
};

export const validatePrice = (price) => {
  if (!price) {
    return "Price is required";
  }
  return "";
};

export const validateDiscount = (discount) => {
  if (!discount) {
    return "Discount is required";
  }
  // Validar que solo contenga números
  const re = /^\d+$/;
  if (!re.test(discount.replace(/[^0-9]/g, ""))) {
    return "Invalid discount format";
  }
  return "";
};

export const validateExpirationDate = (expirationDate) => {
  if (!expirationDate) {
    return "Expiration date is required";
  }
  return "";
};

export const validateLoginForm = (values) => {
  const { email, password } = values;
  const errors = {
    email: validateEmail(email),
    password: validatePassword(password),
  };

  return {
    errors,
    hasErrors: Object.values(errors).some((error) => error !== ""),
  };
};

export const validateForgotPasswordForm = (values) => {
  const { phone, email, code } = values;
  const errors = {
    phone: validatePhone(phone),
    email: validateEmail(email),
    code: validateCode(code),
  };

  return {
    errors,
    hasErrors: Object.values(errors).some((error) => error !== ""),
  };
};

export const validateTokenForm = (values) => {
  const { name, tokens, price } = values;
  const errors = {
    name: validatePackageName(name),
    tokens: validateQuantity(tokens),
    price: validatePrice(price),
  };

  return {
    errors,
    hasErrors: Object.values(errors).some((error) => error !== ""),
  };
};
